export default "__VITE_ASSET__BYhLPD1W__"